import React from 'react';
import styles from "../../styles/competitor-players-stats-module.module.scss";
import classNames from "classnames";
import {ShotMapGoalView} from "../../../../core/components/shot-map/goal-view/shot-map.goal-view";
import {COMPETITOR_PLAYER_STATS} from "../../competitor-players-stats-module.consts";
import {observer} from "mobx-react";
import {ShotMapShotSelector} from "../../../../core/components/shot-map/shot-selector/shot-map.shot-selector";

export const CompetitorPlayersStatsModulePlayerStatsShotMapGoalView = observer(({controller, isGoalViewExpanded}) => {
  const {state} = controller;
  const {game, selectedPlayer, isShallowShotMap} = state;
  const {selectedShot, shots} = selectedPlayer;

  const goalShotsProps = {
    game,
    controller,
    isPlayerPopup: true,
    events: selectedShot !== null ? [selectedShot] : null
  }

  const shotSelectorProps = {
    controller,
    selectedShot,
    shotsLength: shots?.length || 0,
    shouldRenderTypeShot: true,
    onClick: (direction) => controller.action(COMPETITOR_PLAYER_STATS.ACTION_TYPES.onShotSelected, {direction}),
    isShallowShotMapView: isShallowShotMap,
    shouldRenderPlayer: false
  }
  return (
    isGoalViewExpanded || isShallowShotMap ? <div className={classNames(styles.goal_view)}>
      <ShotMapShotSelector {...shotSelectorProps}/>
      {isShallowShotMap ? null : <ShotMapGoalView {...goalShotsProps}/>}
    </div> : null
  )
});
